export default () => {
    localStorage.removeItem('JellyWorkzApiToken')
    window.location.reload()
}